import { Container, Form, Table } from 'react-bootstrap'
import pdfMake from 'pdfmake'

import Navbar from '../../components/navbar/navbar'
import { CustomButton } from '../../components/CustomButton'
import {
  ArrowCounterclockwise,
  CaretDown,
  CaretUp,
  FiletypePdf,
} from 'react-bootstrap-icons'
import { useEffect, useState } from 'react'
import ProdutosService from '../../services/database/ProdutosService'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { CustomSpinner } from '../../components/CustomSpinner'
import ReactPaginate from 'react-paginate'
import { usePaginate } from '../../hooks/usePaginate'
import { useOrderTable } from '../../hooks/useOrderTable'

export function RelatorioEstoqueMinimo() {
  const [products, setProducts] = useState([])
  const [isLoadingProducts, setIsLoadingProducts] = useState(true)

  const {
    sortedArray: sortedProducts,
    check,
    handleOrganize,
    orderType,
  } = useOrderTable(products, 'codproduto')

  const {
    filteredItems: filteredProducts,
    itemsPerPage,
    handlePageClick,
    pageCount,
    setItemsPerPage,
  } = usePaginate(sortedProducts, orderType)

  async function getData() {
    try {
      setIsLoadingProducts(true)

      const data = await ProdutosService.getRelatoriosEstoqueMinimo()

      setProducts(data)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível recuperar os dados, tente novamente mais tarde!',
      )
    } finally {
      setIsLoadingProducts(false)
    }
  }

  function genPDF() {
    const productsFormatted = filteredProducts.map((product) => [
      {
        text: product.codproduto,
        style: 'tableRow',
      },
      {
        text: product.descricao,
        style: 'tableRow',
      },
      {
        text: product.estoque_atual,
        style: 'tableRow',
      },
      {
        text: product.estoque_minimo,
        style: 'tableRow',
      },
    ])

    const docDefinition = {
      content: [
        { text: 'Relatório de Estoque Mínimo', style: 'title' },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'Código', style: 'tableRow' },
                { text: 'Descrição', style: 'tableRow' },
                { text: 'Estoque Atual', style: 'tableRow' },
                { text: 'Estoque Mínimo', style: 'tableRow' },
              ],
              ...productsFormatted,
            ],
          },
          margin: [0, 20],
          layout: {
            fillColor: (rowIndex, _node, _columnIndex) => {
              return rowIndex % 2 === 0 ? '#CCCCCC' : null
            },
          },
        },
      ],
      styles: {
        title: {
          fontSize: 14,
          bold: true,
        },
        tableRow: {
          fontSize: 6,
        },
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Navbar />
      <Container className="mt-page">
        <h1>Relatório de Estoque Mínimo</h1>

        <div
          style={{
            display: 'flex',
          }}
        >
          <CustomButton
            title="Gerar PDF"
            onClick={genPDF}
            isDisabled={filteredProducts.length === 0}
          >
            <FiletypePdf />
          </CustomButton>

          <CustomButton
            title="Recarregar"
            onClick={getData}
          >
            <ArrowCounterclockwise />
          </CustomButton>
        </div>

        <div className="mt-4">
          <Form.Label>Produtos por página</Form.Label>
          <Form.Select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value))
            }}
            style={{
              width: 200,
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </div>

        <div
          style={{
            width: '100%',
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isLoadingProducts ? (
            <CustomSpinner />
          ) : products.length === 0 ? (
            <h1>Sem dados disponíveis</h1>
          ) : (
            <>
              <Table>
                <thead>
                  <tr>
                    <th onClick={() => handleOrganize('codproduto')}>
                      <span>Código</span>
                      <CaretUp color={check('codproduto', 'asc')} />
                      <CaretDown color={check('codproduto', 'desc')} />
                    </th>

                    <th onClick={() => handleOrganize('descricao')}>
                      <span>Descrição</span>
                      <CaretUp color={check('descricao', 'asc')} />
                      <CaretDown color={check('descricao', 'desc')} />
                    </th>

                    <th onClick={() => handleOrganize('estoque_atual')}>
                      <span>Estoque Atual</span>
                      <CaretUp color={check('estoque_atual', 'asc')} />
                      <CaretDown color={check('estoque_atual', 'desc')} />
                    </th>

                    <th onClick={() => handleOrganize('estoque_minimo')}>
                      <span>Estoque Mínimo</span>
                      <CaretUp color={check('estoque_minimo', 'asc')} />
                      <CaretDown color={check('estoque_minimo', 'desc')} />
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filteredProducts.map((product) => (
                    <tr>
                      <td>{product.codproduto}</td>
                      <td>{product.descricao}</td>
                      <td>{product.estoque_atual}</td>
                      <td>{product.estoque_minimo}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <ReactPaginate
                breakLabel="..."
                nextLabel="Próxima"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="Anterior"
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                activeClassName="active"
              />
            </>
          )}
        </div>
      </Container>
    </>
  )
}
